import { USER_ROLE_HOUSEHOLD_ADMIN } from 'common/userRoles';

import { SR_API_ACTION_ADMIN_GET_USERS_WITH_ROLE } from 'api/actionTypes';

export default async function getHouseholdAdminsList({ state, apiClient }, { force } = {}) {
  if (!force && state.get(['householdAdminsList'])) {
    return;
  }
  await apiClient.postWithState({
    action: SR_API_ACTION_ADMIN_GET_USERS_WITH_ROLE,
    payload: {
      userRole: USER_ROLE_HOUSEHOLD_ADMIN,
    },
    queryId: USER_ROLE_HOUSEHOLD_ADMIN,
    state: state,
    onSuccess(householdAdminsList) {
      state.set(['householdAdminsList'], householdAdminsList);
    },
  });
}
